import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import FormLogin from "../../containers/FormLogin/FormLogin";
import en from "react-intl/locale-data/en";
import pt from "react-intl/locale-data/pt";
import { addLocaleData } from "react-intl";
import messages from "../../assets/i18n";
import logoLogin from "./../../assets/images/logos/logos-login.svg";
import "./../../styles/custom-bootstrap.scss";
import "./LoginPage.scss";
import { FlagChoice } from "../../components";
import { Creators as actionLanguage } from "../../store/ducks/language";

//Adicionando os Locales
addLocaleData(pt);
addLocaleData(en);

function LoginPage () {

	const dispatch = useDispatch();
	const lang = useSelector(state => state.language.name);

	useEffect(() => {
		if (!messages[lang]) {
			dispatch(actionLanguage.clear());
		}
	}, [dispatch, lang]);

	return (
		!messages[lang]
			? <></>
			: (
				<div className="login">
					<div className="bg-image" />
					<div className="language-choice text-1 text-color-white d-flex align-items-center">
						<div className="float-left mr-1">{messages[lang].language}</div>
						<div className="float-left"><FlagChoice locale={lang} /></div>
					</div>

					<Container>
						<Row className="align-middle">
							<Col>
								<div className="texts">
									<h1>
										{messages[lang].loginWelcomeTo}
										<br />
										{messages[lang].loginPortal}
									</h1>
									<div className="black-bar" />
									<h2>
										{messages[lang].loginCheckOrders}
										<br />
										{messages[lang].loginAndOrganize}
									</h2>

									<img width="222" src={logoLogin} alt={messages[lang].loginAltImage} title={messages[lang].loginAltImage} />
								</div>
							</Col>
							<Col>
								<div className="elipse">
									<p className="space-between">
										{messages[lang].Login}
									</p>
									<FormLogin />
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			)
	);
}

export default LoginPage;
